import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../utils/locale';
import './TaskBillingStatusBadges.css';

function billingTooltip(t, i18n, flagged, label, byName, at) {
  if (!flagged) {
    return label;
  }
  if (at) {
    return t('tasks:billingMarkedBy', {
      name: byName || t('tasks:unknownSubmitter'),
      datetime: formatDateTime(at, i18n.language)
    });
  }
  return label;
}

function TaskBillingStatusBadges({ task, className = '', iconsOnly = false }) {
  const { t, i18n } = useTranslation(['tasks']);
  if (!task) {
    return null;
  }

  const attested = Boolean(task.attested);
  const invoiced = Boolean(task.invoiced);
  if (!attested && !invoiced) {
    return null;
  }

  const attestedLabel = t('tasks:billingAttested');
  const invoicedLabel = t('tasks:billingInvoiced');
  const attestedTitle = billingTooltip(
    t,
    i18n,
    attested,
    attestedLabel,
    task.attested_by_name,
    task.attested_at
  );
  const invoicedTitle = billingTooltip(
    t,
    i18n,
    invoiced,
    invoicedLabel,
    task.invoiced_by_name,
    task.invoiced_at
  );

  return (
    <span className={`task-billing-badges ${iconsOnly ? 'task-billing-badges--icons' : ''} ${className}`.trim()}>
      {attested && (
        <span
          className="task-billing-badge task-billing-badge--attested"
          title={attestedTitle}
          aria-label={attestedTitle}
        >
          <span className="material-symbols-outlined task-billing-badge-icon" aria-hidden="true">
            verified
          </span>
          {!iconsOnly && <span className="task-billing-badge-text">{attestedLabel}</span>}
        </span>
      )}
      {invoiced && (
        <span
          className="task-billing-badge task-billing-badge--invoiced"
          title={invoicedTitle}
          aria-label={invoicedTitle}
        >
          <span className="material-symbols-outlined task-billing-badge-icon" aria-hidden="true">
            receipt_long
          </span>
          {!iconsOnly && <span className="task-billing-badge-text">{invoicedLabel}</span>}
        </span>
      )}
    </span>
  );
}

export default TaskBillingStatusBadges;
